/* ---------- Lazy video (snelheid): bronnen pas laden als de sectie in beeld komt, na de paginaload ---------- */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function limitAutoplay(v) { return v.hasAttribute('data-pw-autoplay') && (reduce.matches || (navigator.connection && navigator.connection.saveData)); }
  function play(v) { if (limitAutoplay(v)) return; try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
  function hydrate(v) {
    if (v.dataset.poster) { v.poster = v.dataset.poster; }
    if (v.dataset.pwReady || limitAutoplay(v)) return; v.dataset.pwReady = '1';
    v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; s.removeAttribute('data-src'); });
    v.preload = v.hasAttribute('data-pw-autoplay') ? 'auto' : 'metadata';
    v.load();
    var slide = v.closest('.vchap__slide');
    if (v.hasAttribute('data-pw-autoplay') || (slide && slide.classList.contains('is-active'))) {
      var r = v.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) play(v);
    }
  }
  function start() {
    var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-pw-video]:not([data-pw-ready])'));
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(hydrate); vids.forEach(function (v) { if (v.hasAttribute('data-pw-autoplay')) play(v); }); return; }
    var near = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        near.unobserve(e.target);
        e.target.querySelectorAll('video[data-pw-video]').forEach(hydrate);
      });
    }, { rootMargin: '400px 0px' });
    var seen = [];
    vids.forEach(function (v) { var scope = v.closest('section') || v.parentElement; if (seen.indexOf(scope) === -1) { seen.push(scope); near.observe(scope); } });
    var vis = new IntersectionObserver(function (es) {
      es.forEach(function (e) { var v = e.target; if (!v.dataset.pwReady) return; if (e.isIntersecting) play(v); else v.pause(); });
    }, { threshold: 0.15 });
    vids.forEach(function (v) { if (v.hasAttribute('data-pw-autoplay')) vis.observe(v); });
  }
  var started = false;
  function go() { if (started) return; started = true; ('requestIdleCallback' in window) ? requestIdleCallback(start, { timeout: 800 }) : setTimeout(start, 200); }
  if (document.readyState === 'complete') go(); else { window.addEventListener('load', go); setTimeout(go, 3000); }
  document.addEventListener('shopify:section:load', function () { started = false; go(); });
  function preferencesChanged() { document.querySelectorAll('video[data-pw-video]').forEach(function(v) { if (limitAutoplay(v)) v.pause(); }); started = false; go(); }
  if (reduce.addEventListener) reduce.addEventListener('change', preferencesChanged);
  if (navigator.connection && navigator.connection.addEventListener) navigator.connection.addEventListener('change', preferencesChanged);
})();
